import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import Dropzone from 'react-dropzone';

const UploadModal = React.memo((props) => {
    const hideHandler = () => {
        props.hideUploadModal();
    };

    const uploadHandler = () => {
        // if(confirmValue === '') {
        //     setErrorMessage('The Form # is empty');
        //     return;
        // }

        props.uploadExcel();
    };

    const onDrop = (acceptedFiles) => {
        props.setUploadFile(acceptedFiles[0]);
    };

    let label = 'Upload';
    if (props.isUploading) {
        label = <i className="fas fa-circle-notch fa-spin" />;
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Cancel</button>,
        <button key="upload-button" className="btn btn-light btn-sm action-button" onClick={uploadHandler} disabled={props.isUploading}>{label}</button>
    ];
    return (
        <Dialog
            name="upload-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 800 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-forms-upload-dialog"
        >
            <div className="admin-forms-upload-modal-container">
                <h1>Upload Excel</h1>
                <p className="notice">
                    <span>Warning:</span> Uploading an Excel file will update the whole Forms database. It will remove all the Forms that are not present
                    in the Excel file from the database and it will update the information for all the other Forms in the spreadsheet. The file must be in
                    the Master Template format that is exported from this section, with the same Column names and positions.
                    <br />
                    <br />
                    New Forms cannot be uploaded using the Excel file, you must create new Forms using the <b>"Add Form"</b> button. The PDF and Preview files
                    cannot be changed using the spreadsheet.
                </p>
                <Dropzone onDrop={onDrop} accept=".xlsx,.xls">
                    {({ getRootProps, getInputProps }) => (
                        <div className="upload-file-container">
                            <div {...getRootProps()} className="button">
                                <input {...getInputProps()} />
                                Click here to upload a file
                            </div>
                            <div className="file-name">
                                {props.uploadFile != null ? <Fragment><b>Selected File:</b> {props.uploadFile.name}</Fragment> : null}
                            </div>
                        </div>
                    )}
                </Dropzone>
            </div>
        </Dialog >
    );
});

export default UploadModal;
